import { ChartConstants } from "../shared/constants"
import { formatMonatJahr } from "../../shared/formatters"

const MONATSGRENZE_MS = 5 * 365 * 24 * 3600 * 1000

function istMonatsansicht(min, max) {
	return max - min < MONATSGRENZE_MS
}

function setzeAnzeigeformat(chartRiester, min, max) {
	chartRiester.data.anzeigeformat = istMonatsansicht(min, max) ? "monat" : "jahr"
}

export function bewertungsLabelText({ bewertungsdatum, bewertungswert }) {
	return `Bewertung zum ${formatMonatJahr(bewertungsdatum)}`
}

export function buildBewertungsPlotline({ bewertungsdatum, bewertungswert, value }) {
	if (!bewertungsdatum) return null

	return {
		id: "bewertungsplotline",
		color: "#2F3435",
		width: 2,
		dashStyle: "longdashdot",
		zIndex: 10,
		bewertungsdatum: bewertungsdatum,
		value: value ?? bewertungsdatum,
		label: {
			text: bewertungsLabelText({ bewertungsdatum: bewertungsdatum, bewertungswert: bewertungswert }),
			rotation: 0,
			y: 15,
			x: 10,
			textAlign: "left",
			style: { color: ChartConstants.fontColorGrau, fontSize: "14px" },
		},
	}
}

export function updateDataGrouping(chart, min, max) {
	const groupingEnabled = !istMonatsansicht(min, max)

	const plotOptions = {
		plotOptions: {
			series: {
				dataGrouping: {
					enabled: groupingEnabled,
					anchor: "start",
					firstAnchor: "start",
					lastAnchor: "start",
				},
			},
		},
	}

	chart.update(plotOptions)
}

export function zoomIn(chartRiester, event) {
	if (event.resetSelection) {
		chartRiester.onZoomReset?.()
		return true
	}

	const min = event.xAxis[0].min
	const max = event.xAxis[0].max

	chartRiester.onZoomIn?.()
	setzeAnzeigeformat(chartRiester, min, max)

	return true
}

export function updateXAxisMinMax(chartRiester) {
	const seriesMaxValues = chartRiester.chart.series.map((serie) =>
		Array.isArray(serie.xData) ? serie.xData.slice(-1)[0] : undefined,
	)
	const xAxisMaxValue = Math.max(
		chartRiester.data.enddatum,
		...seriesMaxValues.filter((element) => element !== undefined),
	)
	chartRiester.chart.xAxis[0].update({ min: chartRiester.data.startdatum, max: xAxisMaxValue })
}

export function updateBewertungLinie(chartRiester) {
	const xAxis = chartRiester.chart.xAxis[0]
	const bewertungsdatum = chartRiester.data.bewertungsdatum
	const bestehendePlotLines = Array.isArray(xAxis.options.plotLines) ? xAxis.options.plotLines : []
	const plotLine = bestehendePlotLines.find((pl) => pl.id === "bewertungsplotline")
	const anderePlotLines = bestehendePlotLines.filter((pl) => pl.id !== "bewertungsplotline")

	if (!bewertungsdatum) {
		if (plotLine) xAxis.update({ plotLines: anderePlotLines })
		return
	}

	const groupingAktiv = !!chartRiester.chart.options.plotOptions.series.dataGrouping.enabled
	const bewertungsjahr = new Date(bewertungsdatum).getUTCFullYear()
	const gruppierterXWert = groupingAktiv ? gruppierterJahresXWert(chartRiester.chart, bewertungsjahr) : null
	const naechstePlotLine = {
		...(plotLine || {}),
		...buildBewertungsPlotline({
			bewertungsdatum: chartRiester.data.bewertungsdatum,
			bewertungswert: chartRiester.data.bewertungswert,
			value: groupingAktiv ? (gruppierterXWert ?? Date.UTC(bewertungsjahr, 0, 1)) : bewertungsdatum,
		}),
	}

	xAxis.update({ plotLines: [...anderePlotLines, naechstePlotLine] })
}

function gruppierterJahresXWert(chart, jahr) {
	const jahreszeitpunkt = (x) => new Date(x).getUTCFullYear() === jahr

	for (const serie of chart.series) {
		if (!Array.isArray(serie.xData) || serie.xData.length === 0) continue
		const xWert = serie.xData.find((x) => typeof x === "number" && jahreszeitpunkt(x))
		if (xWert) return xWert
	}

	return null
}

export function defaultChartOptions() {
	return {
		plotOptions: {
			series: {
				animation: {
					duration: ChartConstants.animationDuration,
					easing: "easeInOut",
				},
				animationLimit: Infinity,
			},
			area: {
				stacking: "normal",
			},
		},
	}
}
